import { render, staticRenderFns } from "./GlyphComponent.vue?vue&type=template&id=68037a4b&scoped=true&"
import script from "./GlyphComponent.vue?vue&type=script&lang=js&"
export * from "./GlyphComponent.vue?vue&type=script&lang=js&"
import style0 from "./GlyphComponent.vue?vue&type=style&index=0&id=68037a4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68037a4b",
  null
  
)

export default component.exports